import {
  faBriefcase,
  faChevronLeft,
  faNetworkWired,
} from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import ProfileLogo from '~/components/office/ProfileLogo';
import Container from '~/components/ui/Container';
import { Link } from '~/components/ui/Link';
import { cn } from '~/helpers/utils';
import type { CompanyBannerSettings, CompanyType } from '~/types/Company';

type BackButton = {
  link: string;
  type: CompanyType;
};

type CompanyBannerProps = {
  banner?: CompanyBannerSettings;
  companyName: string;
  companyLogo?: string;
  companyType: CompanyType;
  backButton?: BackButton;
};

const OPTIONS = {
  chain: { icon: faNetworkWired, label: 'Keten profiel' },
  provider: { icon: faBriefcase, label: 'Aanbieder profiel' },
};

const CompanyBanner: React.FC<CompanyBannerProps> = ({
  banner,
  companyName,
  companyLogo,
  companyType,
  backButton,
}) => {
  const { icon, label } = OPTIONS[companyType];

  return (
    <div className="company-banner relative z-10">
      <div
        className={cn(
          'relative overflow-hidden bg-blue-700',
          banner ? 'pb-24 pt-40 md:pb-40 md:pt-32' : 'pb-24 pt-16'
        )}
      >
        {banner && (
          <img
            src={banner.url}
            alt={`Profiel banner van ${companyName}`}
            className={cn(
              'absolute left-1/2 top-0 z-10 -translate-x-1/2 opacity-60',
              'h-full w-full max-w-[2240px] object-cover',
              'object-center', // Defaults to center
              banner.orientationType === 'top' && 'object-top',
              banner.orientationType === 'bottom' && 'object-bottom'
            )}
          />
        )}
        <Container className="relative z-20">
          <div className="flex flex-col md:flex-row">
            <div className="flex flex-row gap-4 md:gap-10">
              <ProfileLogo
                src={companyLogo}
                alt={`Logo van ${companyName}`}
                widthClass="w-20 h-20 md:w-32 md:h-32"
              />
              <div className="flex flex-col justify-center gap-1">
                <h1 className="font-display text-xl font-bold text-white md:text-3xl">
                  {companyName}
                </h1>
                <span className="flex items-center gap-2 font-display font-bold text-white/80">
                  <FontAwesomeIcon icon={icon} />
                  {label}
                </span>
              </div>
            </div>

            {backButton && (
              <div className="mt-2 md:ml-auto md:mt-auto">
                <Link
                  variant="default"
                  className="button--back"
                  href={backButton.link}
                >
                  <FontAwesomeIcon icon={faChevronLeft} />
                  Ga terug naar de{' '}
                  {backButton.type === 'chain'
                    ? 'ketenpagina'
                    : 'aanbiederpagina'}
                </Link>
              </div>
            )}
          </div>
        </Container>
      </div>
    </div>
  );
};

export default CompanyBanner;
